import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import HomeActions from "./actions";
import {ExportFormat, HomeState, IndexItem, MetricItem} from "./model";
import { store } from "application/store";
import moment, {Moment} from "moment";

const initialState: HomeState = {
  isOnLoad: true,
  data: null,
  selectedIndexes: [],
  selectedMetrics: [],
  dateFrom: moment().subtract(5, "years"),
  dateTo: moment(),
  documentType: "CSV",
};

export const homeSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setSelectedIndexes: (state, action: PayloadAction<IndexItem[]>) => {
      state.selectedIndexes = action.payload;
    },
    setSelectedMetrics: (state, action: PayloadAction<MetricItem[]>) => {
      state.selectedMetrics = action.payload;
    },
    setDateFrom: (state, action: PayloadAction<Moment>) => {
      state.dateFrom = action.payload;
    },
    setDateTo: (state, action: PayloadAction<Moment>) => {
      state.dateTo = action.payload;
    },
    setDocumentType: (state, action: PayloadAction<ExportFormat>) => {
      state.documentType = action.payload;
    },
  },
  extraReducers: (builder) => {
    // onLoad
    builder.addCase(HomeActions.getMetricsAndIndexes.fulfilled, (state, { payload }) => {
      state.isOnLoad = false;
      state.data = payload;
    });
    builder.addCase(HomeActions.getMetricsAndIndexes.rejected, (state, payload) => {
      state.isOnLoad = false;
    });
  },
});

export default homeSlice.reducer;
export const homeSelector = () => store.getState().home;
export const {
  setSelectedIndexes, setSelectedMetrics, setDateTo, setDateFrom, setDocumentType
} = homeSlice.actions;
